import React, {ReactNode, useEffect} from 'react'
import {GroupType} from '../../types/app-types'
import {useAppSelector} from '../../store/hooks'
import {selectHasAllGroups} from '../../store/userSlice'
import {useNavigate} from 'react-router-dom'

interface RequiresGroupsProps {
  children: ReactNode
  groups: GroupType[]
}

const RequiresGroups = ({children, groups}: RequiresGroupsProps) => {
  const navigate = useNavigate()
  const allowAccess = useAppSelector(selectHasAllGroups(groups))

  useEffect(() => {
    if (!allowAccess) {
      console.log('Access denied')
      navigate('/access-denied')
    }
  }, [])

  return <>{children}</>
}

export default RequiresGroups
